/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListCopyGroupRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {ListCopyGroupResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const listCopyGroup = (request:ListCopyGroupRequest, options?: CashRequestOptions) => post<ListCopyGroupRequest, ListCopyGroupResponse>("/2.0/cash/list-copy-group", request, {...options, rejectOnError: true })